import { render, staticRenderFns } from "./PropertyNumber.vue?vue&type=template&id=70fb710f&scoped=true"
import script from "./PropertyNumber.vue?vue&type=script&lang=ts"
export * from "./PropertyNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb710f",
  null
  
)

export default component.exports